<template>
<div>
  <MobileNavigation></MobileNavigation>
      
    <div class="max-w-7xl mx-auto sm:px-6 lg:px-8 bg-slate-900" style="height:100%">
      <br><br><br>
      <div class="p-1">
        <!-- <span class="text-2xl font-weight-bold mt-2">Payslips</span><br> -->
        <div class="" v-for="(d, b) in payslips" :key="b" >
          <div class="bg-white shadow rounded-lg border mt-2">
            <div class="p-2 grid grid-cols-2 gap-1">
              <span class="pl-2 text-2xl">{{ d.name }}</span>
              <div class="text-right">
                <input type="checkbox" name="payslip" @change="updateStatus" :value="d.name">
              </div>
            </div>
            <div class="p-2 grid grid-cols-2 gap-1">
              <span class="text-xl font-weight-bold">{{ d.date }}</span>
              <div class="text-right">
                <a v-bind:href="d.url" class="no-decoration" target="_self"><i class="fas fa-eye text-black text-lg p-3 text-right"></i></a>
                <a v-bind:href="d.url" class="no-decoration" target="_blank"><i class="fas fa-cloud-download-alt text-black p-3 text-right text-lg"></i></a>
              </div>
            </div>
          </div>
        </div>

        <button class="downloadButton shadow rounded-full bg-blue-500 " v-on:click="bulkDownload">
          <i class="fas fa-cloud-download-alt text-white"></i>
        </button>
      </div>

    </div>     

  </div>
</template>
<style scoped>
    .noselect {
        -webkit-touch-callout: none;
        /* iOS Safari */
        -webkit-user-select: none;
        /* Safari */
        -khtml-user-select: none;
        /* Konqueror HTML */
        -moz-user-select: none;
        /* Firefox */
        -ms-user-select: none;
        /* Internet Explorer/Edge */
        user-select: none;
        /* Non-prefixed version, currently
                                  supported by Chrome and Opera */
    }

    .no-decoration{
      text-decoration: none;
    }

    .no-decoration:hover{
       text-decoration: none;
    }

    .downloadButton {
      position: fixed;
      bottom: 20px;
      right: 20px; 
      padding-left: 20px;
      padding-right: 20px;
      padding-top: 6px;
      padding-bottom: 6px;
    }

    </style>

<script>
import Welcome from "@/Jetstream/Welcome.vue";
import PageTitle from "@/Layouts/PageTitle.vue";
import JetNavLink from '@/Jetstream/NavLink.vue'
import MobileNavigation from "@/Layouts/MobileNavigation.vue";

export default {
  props: ["sessions"],

  components: {
    Welcome,
    PageTitle,
    JetNavLink,
    MobileNavigation,
  },
  data() {
    return {
      title: "Payslips",
      payslips:null,
      payslipsList: [],

    };
  },
    methods: {
    initView() {
      document.getElementById("mobile-menu-checkbox").checked = false;
      this.renderList();
    },
    
  updateStatus(e){
      if(e.target.checked){
          this.payslipsList.push(e.target.value);
          console.log(this.payslipsList);
      } else {
          this.payslipsList.splice(this.payslipsList.indexOf(e.target.value), 1);
          console.log(this.payslipsList);
      }
  },
    bulkDownload(){
      console.log(this.payslipsList);
    },
    renderList(){
      let data = [
            {
              name: "Payslips'20",
              date: "18/01/2020",
              uri: "https://canvas.upenn.edu/courses/1320001/files/58787877/download?download_frd=1"
            },
            {
              name: "Payslips'24",
              date: "18/02/2020",
              uri: "https://canvas.upenn.edu/courses/1320001/files/58787877/download?download_frd=1"
            },
            {
              name: "Payslips'25",
              date: "18/03/2020",
              uri: "https://canvas.upenn.edu/courses/1320001/files/58787877/download?download_frd=1"
            },
            {
              name: "Payslips'28",
              date: "18/04/2020",
              uri: "https://canvas.upenn.edu/courses/1320001/files/58787877/download?download_frd=1"
            },
            {
              name: "Payslips'28",
              date: "18/04/2020",
              uri: "https://canvas.upenn.edu/courses/1320001/files/58787877/download?download_frd=1"
            },
            {
              name: "Payslips'28",
              date: "18/04/2020",
              uri: "https://canvas.upenn.edu/courses/1320001/files/58787877/download?download_frd=1"
            },
            {
              name: "Payslips'28",
              date: "18/04/2020",
              uri: "https://canvas.upenn.edu/courses/1320001/files/58787877/download?download_frd=1"
            },
            {
              name: "Payslips'28",
              date: "18/04/2020",
              uri: "https://canvas.upenn.edu/courses/1320001/files/58787877/download?download_frd=1"
            },
            {
              name: "Payslips'28",
              date: "18/04/2020",
              uri: "https://canvas.upenn.edu/courses/1320001/files/58787877/download?download_frd=1"
            },
            {
              name: "Payslips'28",
              date: "18/04/2020",
              uri: "https://canvas.upenn.edu/courses/1320001/files/58787877/download?download_frd=1"
            },
            {
              name: "Payslips'28",
              date: "18/04/2020",
              uri: "https://canvas.upenn.edu/courses/1320001/files/58787877/download?download_frd=1"
            },
            {
              name: "Payslips'28",
              date: "18/04/2020",
              uri: "https://canvas.upenn.edu/courses/1320001/files/58787877/download?download_frd=1"
            },
            {
              name: "Payslips'28",
              date: "18/04/2020",
              uri: "https://canvas.upenn.edu/courses/1320001/files/58787877/download?download_frd=1"
            },
            {
              name: "Payslips'28",
              date: "18/04/2020",
              uri: "https://canvas.upenn.edu/courses/1320001/files/58787877/download?download_frd=1"
            }
          ];
          console.log(data);

        this.payslips = data;
    }
    // downloadURI(uri, name) {
    //     var link = document.createElement("a");
    //     // If you don't know the name or want to use
    //     // the webserver default set name = ''
    //     link.setAttribute('download', name);
    //     link.href = uri;
    //     document.body.appendChild(link);
    //     link.click();
    //     link.remove();
    // }
  },
  mounted() {
    this.initView();
  },
};
</script>
